import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocialMediaService {
  constructor(private http: HttpClient) {}

  // Fetch details of the product or article
  getContentDetails(contentId: string, type: 'product' | 'article'): Observable<any> {
    return this.http.get(`/api/content/details?contentId=${contentId}&type=${type}`);
  }

  // Schedule a post with selected image, description, and post time
  schedulePost(postData: any): Observable<any> {
    return this.http.post('/api/social-media/schedule', postData);
  }
}
